import React from 'react';
import { CheckCircle2, Loader2, Printer, X } from 'lucide-react';

import ModalPortal from '../../components/ModalPortal';
import { fmt } from './posV2Utils';

/**
 * Petite fenêtre post-encaissement : proposer l'impression ticket 80mm.
 * Le bouton discret dans le panneau checkout reste en secours.
 */
const PosV2PrintTicketModal = ({
  open,
  sale,
  printing,
  onPrint,
  onSkip,
}) => {
  if (!open || !sale) return null;

  return (
    <ModalPortal isOpen={open}>
      <div
        className="w-full max-w-sm rounded-2xl border border-white/10 bg-[#151820] shadow-2xl overflow-hidden"
        data-testid="pos-v2-print-ticket-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="pos-v2-print-ticket-title"
      >
        <div className="flex items-start justify-between gap-3 px-5 pt-5 pb-2">
          <div className="flex items-start gap-3 min-w-0">
            <div className="mt-0.5 rounded-full bg-emerald-500/15 p-2 text-emerald-400 shrink-0">
              <CheckCircle2 size={22} />
            </div>
            <div className="min-w-0">
              <h3 id="pos-v2-print-ticket-title" className="font-bold text-lg text-white leading-tight">
                Vente validée
              </h3>
              <p className="text-sm text-gray-400 mt-1 truncate font-mono">
                {sale.ref_vente}
                {sale.magasin_id ? ` · ${sale.magasin_id}` : ''}
              </p>
              <p className="text-xl font-bold text-white mt-2">
                {fmt(sale.total)} €
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onSkip}
            className="p-2 rounded-lg text-gray-400 hover:text-white hover:bg-white/10 shrink-0"
            aria-label="Fermer"
            disabled={printing}
          >
            <X size={18} />
          </button>
        </div>

        <div className="px-5 pb-5 pt-3 space-y-3">
          <p className="text-sm text-gray-300">
            Imprimer le ticket 80&nbsp;mm sur l&apos;Epson&nbsp;?
          </p>
          <button
            type="button"
            onClick={onPrint}
            disabled={printing || sale.__offline}
            className="w-full min-h-[52px] rounded-xl bg-red-600 hover:bg-red-500 disabled:opacity-40 font-bold text-base text-white flex items-center justify-center gap-2 shadow-lg shadow-red-900/30"
            data-testid="pos-v2-print-ticket-yes"
          >
            {printing ? (
              <Loader2 className="animate-spin" size={20} />
            ) : (
              <Printer size={20} />
            )}
            {printing ? 'Impression…' : 'Oui, imprimer'}
          </button>
          <button
            type="button"
            onClick={onSkip}
            disabled={printing}
            className="w-full min-h-[44px] rounded-xl border border-white/15 bg-white/5 hover:bg-white/10 text-gray-200 font-semibold text-sm"
            data-testid="pos-v2-print-ticket-no"
          >
            Non, plus tard
          </button>
          {sale.__offline && (
            <p className="text-[11px] text-amber-300 text-center">
              Vente en file offline — impression dispo après sync.
            </p>
          )}
        </div>
      </div>
    </ModalPortal>
  );
};

export default PosV2PrintTicketModal;
